<template>
  <div class="custom-toast top-right" :style="customPosition">
    <div class="toast-icon">
      <!-- <i class="material-icons" :class="type">{{icon}}</i> -->
      <md-icon class="material-icons" :class="type">{{icon}}</md-icon>
    </div>
    <div class="toast-message" v-html="message"></div>
    <button class="toast-close" @click="close">×</button>
  </div>
</template>

<script>
export default {
  name: "notification",
  props: {
    message: String,
    icon: String,
    verticalAlign: {
      type: String,
      default: "top"
    },
    horizontalAlign: {
      type: String,
      default: "center"
    },
    type: {
      type: String,
      default: "info"
    },
    timeout: {
      type: Number,
      default: 5000
    },
    timestamp: {
      type: Date,
      default: () => new Date()
    }
  },
  data() {
    return {
      elmHeight: 0
    };
  },
  computed: {
    hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType() {
      return `alert-${this.type}`;
    },
    customPosition() {
      let initialMargin = 20;
      let alertHeight = this.elmHeight + 10;
      let sameAlertsCount = this.$notifications.state.filter(alert => {
        return (
          alert.horizontalAlign === this.horizontalAlign &&
          alert.verticalAlign === this.verticalAlign &&
          alert.timestamp <= this.timestamp
        );
      }).length;
      let pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      let styles = {};
      if (this.verticalAlign === "top") {
        styles.top = `${pixels}px`;
      } else {
        styles.bottom = `${pixels}px`;
      }
      return styles;
    }
  },
  methods: {
    close() {
      this.$emit("on-close", this.timestamp);
    }
  },
  mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
};
</script>

<style scoped lang="scss">
  .custom-toast {
    display: flex;
    align-items: center;
    background-color: #1e2a3c;
    color: #ffffff;
    border-radius: 999px;
    padding: 8px 16px;
    min-height: 40px;
    max-width: 90%;
    width: fit-content;
    font-size: 13px;
    line-height: 1.4;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    position: fixed;
    z-index: 3000; 
  
    &.top-right {
      top: 20px;
      right: 20px;
    }
  
    .toast-icon {
      width: 24px;
      height: 24px;
      background-color: #ffffff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      flex-shrink: 0;
  
      .md-icon {
        font-size: 12px;
        color: #4caf50;
        font-size: 20px !important;
      }
    }
  
    .toast-message {
      color: #ffffff;
      margin-right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
  
    .toast-close {
      width: 20px;
      height: 20px;
      font-size: 12px;
      background-color: transparent;
      border: 1px solid rgba(255, 255, 255, 0.4);
      color: #ffffff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
    }
  }
  
  @media screen and (max-width: 600px) {
    .custom-toast {
      padding: 6px 12px;
      font-size: 12px;
      max-width: 95%;
      right: 10px;
  
      .toast-icon {
        width: 20px;
        height: 20px;
  
        md-icon {
          font-size: 13px;
        }
      }
  
      .toast-close {
        width: 18px;
        height: 18px;
        font-size: 11px;
      }
  
      .toast-message {
        max-width: 160px;
      }
    }
  }
  </style>
  
  
  